module.exports = __webpack_public_path__ + "static/1930441_21670297223_2974_n-ff25724956978118dac07725045ca7d5.jpg";